import React, { useEffect, useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router";
import "./style/openshop.css";
function OpenShop() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { logOut, user } = UserAuth();
  const [printName, setPrintName] = useState("");
  const [numOfPages, setNumOfPages] = useState(0);
  const [printablePages, setPrintablePages] = useState("");
  const [uuid, setUuid] = useState("");
  const [url, setUrl] = useState("");
  const [color, setColor] = useState("");
  const [username, setUsername] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const checkifopen = async () => {
    if (user.email) {
      axios
        .post("https://dfghtyudgh.onrender.com/store/status", {
          email: user.email,
        })
        .then((data) => {
          if (data.data.status === "open") {
            console.log(data.data);
            setOpen(true);
            navigate('/dashboard/openshop')
          }
        });
    }
  };
  const handleOpenShop = async () => {
    if (user.email) {
      axios
        .post("https://dfghtyudgh.onrender.com/store/open", {
          email: user.email,
        })
        .then((data) => {
          setOpen(true)
        });
    }
  };

  const fetchNextOrder = async () => {
    axios.get("https://dfghtyudgh.onrender.com/orders/next").then((data) => {
      let all_data = data.data.items[0];
      if (all_data) {
        setPrintName(all_data.nameorder);
        setNumOfPages(all_data.numcopies);
        setPrintablePages(all_data.pages);
        setUuid(all_data.key);
        setPdfUrl(all_data.downloadurl);
        setUsername(all_data.name);
        setUserEmail(all_data.email);
        setColor(all_data.color);
      }
    });
  };
  const closeShop = async () => {
    if (user.email) {
      axios
        .post("https://dfghtyudgh.onrender.com/store/close", {
          email: user.email,
        })
        .then((data) => {
          console.log(data)
          setOpen(false);
          navigate("/dashboard");
        });
    }
  };
  useEffect(() => {
    checkifopen();
  }, []);
  return (
    <div className="open-container">
      {open ? (
        <>
          <div className="p-2 flex max-h-full">
            <div className="w-1/4 pr-4">
              <div className="mb-6">
                <h2 className="text-2xl font-bold mb-2">
                  Basic Data Rendering
                </h2>
                <div className="text-lg">
                  <p>
                    <strong>Print Name:</strong> {printName}
                  </p>
                  <p>
                    <strong>Number of Pages:</strong> {numOfPages}
                  </p>
                  <p>
                    <strong>Printable Pages:</strong> {printablePages}
                  </p>
                  <p>
                    <strong>UUID:</strong> {uuid}
                  </p>
                  <p>
                    <strong>Color:</strong> {color}
                  </p>
                  <p>
                    <strong>Username:</strong> {username}
                  </p>
                  <p>
                    <strong>User Email:</strong> {userEmail}
                  </p>
                  <p>
                    <strong>PDF URL:</strong> {pdfUrl}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-3/4">
              <div className="mb-6">
                {pdfUrl != null ? (
                  <object data={pdfUrl} height={800} width={500} />
                ) : (
                  <></>
                )}
              </div>
              <div className="flex flex-row items-center">
                <button
                  onClick={()=>{closeShop()}}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-2"
                >
                  Close Shop
                </button>
                <button
                  onClick={fetchNextOrder}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-2"
                >
                  Fetch
                </button>
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                  Completed
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <h1 className="title">Open Shop</h1>
          <div className="open-content">
            <p>Click the button below to open your shop.</p>
            <button className="open-button" onClick={handleOpenShop}>
              Open Shop
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default OpenShop;
